import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { Idle } from '@ng-idle/core';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'app-timeout-dialog',
  template: ` <h2 mat-dialog-title>Session Timeout</h2>
    <mat-dialog-content>
      <span> You will be logged out in {{ seconds$ | async }} seconds </span>
    </mat-dialog-content>`,
  standalone: true,
  providers: [Idle],
  imports: [CommonModule, MatDialogModule]
})
export class TimeoutDialogComponent {
  seconds$ = this.idle.onTimeoutWarning.pipe(startWith(this.idle.getTimeout()));

  constructor(
    public dialogRef: MatDialogRef<TimeoutDialogComponent>,
    private idle: Idle
  ) {}
}
